export default __webpack_public_path__ + "static/font-39488ab7926be8f2e9422b63eac20051.woff2";